export const platformBtnFocusType = {
  notFocus: 0,
  funnow: 1,
  funbook: 2
}
